<template>
  <div v-if="project != null">
    <h1>ASPECTO SOCIAL</h1>
    <table class="table" >
      <thead>
      </thead>
      <tbody>        
        <tr>
          <td width="20%;">
            ¿Cuál es la motivación del colaborador para teletrabajar?
          </td>
          <td width="80%;">
            <input type="text" name="motivation_telework" class="form-control" id="motivation_telework" placeholder="" v-model="project.motivation_telework"/>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            ¿Cuáles considera que son los retos para trabajar en esta modalidad?
          </td>
          <td width="80%;">
            <input type="text" name="challenge_telework" class="form-control" id="challenge_telework" placeholder="" v-model="project.challenge_telework"/>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            ¿Qué otras actividades realiza de manera virtual?
          </td>
          <td width="80%;">
            <input type="text" name="activities_telework" class="form-control" id="activities_telework" placeholder="" v-model="project.activities_telework"/>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            ¿Ha tenido otras experiencias teletrabajando?
          </td>
          <td width="80%;">
            <input type="text" name="experience_telework" class="form-control" id="experience_telework" placeholder="" v-model="project.experience_telework"/>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            ¿Cree que cuenta con las herramientas adecuadas para el teletrabajo?
          </td>
          <td width="80%;">
            <input type="text" name="tools_telework" class="form-control" id="tools_telework" placeholder="" v-model="project.tools_telework"/>
          </td>
        </tr>                                        
        <tr>
          <td width="20%;">
            ¿Qué actividades realiza en su tiempo libre?
          </td>
          <td width="80%;">
            <input type="text" name="social_aspects_free_time_activities" class="form-control" id="social_aspects_free_time_activities" placeholder="" v-model="project.social_aspects_free_time_activities"/>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            ¿Cómo afectaría el teletrabajo en su cotidianidad?
          </td>
          <td width="80%;">
            <input type="text" name="affect_telework" class="form-control" id="affect_telework" placeholder="" v-model="project.affect_telework"/>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            ¿Cómo cree que afectaría el teletrabajo en su dinámica familiar?
          </td>
          <td width="80%;">
            <input type="text" name="affect_family_telework" class="form-control" id="affect_family_telework" placeholder="" v-model="project.affect_family_telework"/>
          </td>
        </tr>                
      </tbody>
    </table>
    <b-button variant="primary" @click.prevent="save">Guardar</b-button>
		<div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>    
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
import SelectLocal from './../../own/select-local.vue'

export default {
  name: 'SocialApect',
  props: ['project_id', 'assignment_id'],  
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },  
  data() {
    return {
			message: '',
			typeMessage: ''
    }
  },
  components: {
    'select-local': SelectLocal,
  },  
  methods: {
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
      console.log("3***")
			axios.get(`/information_work.json?project_id=${this.project_id}&assignment_id=${this.assignment_id}`).then(res=>{
				if(res.status == 200){
          this.changeProjectId(this.project_id)
          this.changeAssignmentId(this.assignment_id)
          this.changeProject(res.data.project)
          this.changeAssignment(res.data.assignment)
          this.changeSelects(res.data.selects)
				}
			})
    },
    save(){
      this.defaultAxios()
      let project = this.project
      delete project.family_compositions
      delete project.family_references      
      delete project.family_sicks
      delete project.family_interviews
      delete project.working_condition
			axios.put(`/update_information_personal`, { project: project }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Proceso actualizado', 'alert-success')
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},        
  },
  created () {

  },
  watch: {
    data(newValue, oldValue) {
      
    }
  },
  filters: {
    fnName: function(value) {
      return value;
    }
  }
}
</script>

<style scoped>

</style>